import { FETCH_EVENT_STATS } from '../actions/actionTypes';

const preState = { eventStats: null };

const statsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, stats } = action;

	switch (type) {
		case FETCH_EVENT_STATS:
			return { ...stateDup, stats };
		default:
			return stateDup;
	}
};

export default statsReducer;
